import restraunt from "../assets/restraunt.png";
import elearning from "../assets/elearning.png";
import hostinger from "../assets/hostinger.png";

const cardData = [
  {
    id: "1",
    imgSrc: restraunt,
    title: "Restaurant Website",
    text: "A Restaurant website built with Reactjs using redux for cart functionality and react router with Css for styling.",
    view: "https://restraunt-site.web.app/home",
    gitHub: "https://github.com/davey2000/Restaurant-Site",
  },
  {
    id: "2",
    imgSrc: elearning,
    title: "E-Learning Website",
    text: "A beautiful e-learning website built with Next.js and Tailwind css for styling.",
    view: "https://nextjs-e-learning-site.vercel.app",
    gitHub: "https://github.com/davey2000/nextjs-e-learning-site/tree/master",
  },
  {
    id: "3",
    imgSrc: hostinger,
    title: "Hostinger Website UI Redesign",
    text: "A redesign of the Hostinger website UI. Built with Next.js and Tailwind css for styling.",
    view: "https://nextjs-hostinger-redesign.vercel.app/",
    gitHub:
      "https://github.com/davey2000/Nextjs-Hostinger-Redesign/tree/master",
  },
];

export default cardData;
